import { getSliceGroqQuery } from '@livewire/website/lib/getSliceGroqQuery';

const magicMediaGroq = getSliceGroqQuery(``);

export default magicMediaGroq;
